
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedbacks",
      function () {
        return require("private-next-pages/feedbacks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feedbacks"])
      });
    }
  